import { FormLabel, Input } from '@chakra-ui/react';
import { useState } from 'react';
import { useAsyncDebounce } from 'react-table';

type Global = {
  globalFilter: string;
  setGlobalFilter: (value: string) => void;
};

type Column = {
  column: {
    filterValue: string;
    preFilteredRows: {
      length: string;
    };
    setFilter: (value: string) => void;
    id?: string;
  };
};

export const GlobalFilter = ({
  globalFilter,
  setGlobalFilter
}: Global): JSX.Element => {
  const [value, setValue] = useState(globalFilter);

  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 200);

  return (
    <div>
      <FormLabel>Search Table: </FormLabel>
      <Input
        value={value || ''}
        onChange={(e: any) => {
          setValue(e.target.value);
          onChange(e.target.value);
        }}
        placeholder=" Enter value "
        className="w-25"
        style={{
          fontSize: '1.1rem',
          margin: '1rem',
          display: 'inline'
        }}
      />
    </div>
  );
};

// Component for Default Column Filter
export const DefaultFilterForColumn = ({
  column: {
    filterValue,
    preFilteredRows: { length },
    setFilter
  }
}: Column): JSX.Element => {
  return (
    <Input
      value={filterValue || ''}
      onChange={(e: any) => {
        // Set undefined to remove the filter entirely
        setFilter(e.target.value || undefined);
      }}
      placeholder={`Search ${length} records..`}
      style={{ marginTop: '.6rem' }}
    />
  );
};

// Component for Custom Select Filter
// export const SelectColumnFilter = ({
//   column: { filterValue, setFilter, preFilteredRows, id }
// }: Column): JSX.Element => {
//   // Use preFilteredRows to calculate the options
//   const options = useMemo(() => {
//     const options = new Set();
//     preFilteredRows.forEach((row) => {
//       options.add(row.values[id]);
//     });
//     return [...options.values()];
//   }, [id, preFilteredRows]);

//   // UI for Multi-Select box
//   return (
//     <select
//       value={filterValue}
//       onChange={(e) => {
//         setFilter(e.target.value || undefined);
//       }}
//     >
//       <option value="">All</option>
//       {options.map((option, i) => (
//         <option key={i} value={option}>
//           {option}
//         </option>
//       ))}
//     </select>
//   );
// };
